import { IHouseData, IPlayerSearchResult } from '~/rage';
import { createSlice } from '../wrappers';

const initialState = {
	activeMenu: 'home',
	selectedPlayer: { characterId: '', nickname: '' } as IPlayerSearchResult,
	isClosed: false,
	isFree: false,
	isOwner: true,
	houseData: null as IHouseData | null,
	inputFocused: false,
};

const homeBuyingSlice = createSlice({
	name: 'homeBuying',
	initialState,
	reducers: {
		setActiveMenu: (state, action) => {
			state.activeMenu = action.payload;
		},
		setSelectedPlayer: (state, action) => {
			state.selectedPlayer = action.payload;
		},
		setIsClosed: (state, action) => {
			state.isClosed = action.payload;
		},
		setIsFree: (state, action) => {
			state.isFree = action.payload;
		},
		setIsOwner: (state, action) => {
			state.isOwner = action.payload;
		},
		setHouseData: (state, action) => {
			state.houseData = action.payload;
		},
		setInputFocused: (state, action) => {
			state.inputFocused = action.payload;
		},
	},
});

export const {
	setActiveMenu,
	setSelectedPlayer,
	setIsClosed,
	setIsFree,
	setIsOwner,
	setHouseData,
	setInputFocused,
} = homeBuyingSlice.actions;

export default homeBuyingSlice.reducer;
